<template>
  <div class="table-responsive" style="overflow-x: auto; max-width: 100%;">
    <div class="card">
      <h5 class="card-header">Search Filter</h5>
      <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
        <div class="col-md-6 col-sm-12">
          <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
        </div>
      </div>
      <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
        <div class="col-lg-4 mb-1 col-sm-12">
          <button type="button" class="btn btn-sm btn-primary"  @click="onSubmitFilters" >Search</button>
          <button type="button" class="ml-1 btn-sm btn btn-danger " @click="clear" >Clear</button>
        </div>
      </div>

    </div>
    <CommonTable
        :url="url"
        :tableHeaderValues="tableHeaderValues"
        :actions="actions"
        :deleteActions="deleteActions"
        :mutedData="mutedData"
        :storageKey="storageKey"
        :filteredData="filteredData"
        :externalTotalRecord="externalTotalRecord"
        :show-per-page="true"
    />
  </div>
</template>

<script>

export default {
  props:['filter'],
  mounted() {
    localStorage.setItem("url", "v1/get-store");
    this.checkDataInStore('v1/get-store')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    this.filteredData = this.filter
  },
  data() {
    return {
      url: "v1/get-store",
      storageKey: "merchantInnerStoreList",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == true) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }


            return html;
          }
        }
      ],
      actions: [],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      filteredData:{},
      search:'',
    };
  },
  methods:{
    onSubmitFilters() {

      let filterData = {...this.filter}

      if(this.search != ''){
        filterData.search = this.search
      }

      this.filteredData = {...filterData}

    },
    clear(){
      this.search = ''
      this.filteredData = {...this.filter}
    },
  }
};
</script>
